import { Component, OnInit, HostListener } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ApprovalService } from '../../services/approval.service';
import { PermissionService } from '../../services/permission.service';
import { canViewFeature } from '../../guards/route-roles';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit {
  // ==========================================================================
  // Menu gom theo NHÓM CÔNG VIỆC. Máy tính hiện nhóm ở thanh ngang trên cùng,
  // các tác vụ của nhóm đang mở nằm ở hàng tab ngay dưới. Điện thoại vẫn dùng
  // drawer cũ, đọc đúng mảng này.
  //
  // `feature` = key trong FEATURES (core/guards/route-roles.ts). Mục chỉ hiện
  // khi VỊ TRÍ của tài khoản có quyền XEM feature đó — cùng một bảng quyền mà
  // RoleGuard dùng để chặn route, chỉnh tại /fox-admin/settings/position.
  // Nhóm bị lọc hết tác vụ sẽ tự biến mất khỏi thanh nhóm.
  // ==========================================================================
  menus: any = [
    {
      id: 0,
      title: 'Dashboard',
      url: '/fox-admin',
      icon: 'home',
      selected: false,
      feature: 'dashboard',
    },
    {
      id: 100,
      title: 'Bán hàng',
      icon: 'shopping-cart',
      selected: false,
      children: [
        { id: 2, title: 'Tạo hóa đơn', url: '/fox-admin/order', icon: 'file-add', selected: false, feature: 'order' },
        { id: 1, title: 'Danh sách hóa đơn', url: '/fox-admin/order-list', icon: 'file-text', selected: false, feature: 'order-list' },
        { id: 8, title: 'Mobile/POS', url: '/fox-admin/mobile', icon: 'mobile', selected: false, feature: 'mobile' },
      ],
    },
    {
      id: 200,
      title: 'Dịch vụ',
      icon: 'tool',
      selected: false,
      children: [
        { id: 41, title: 'Nhập phiếu đan vợt', url: '/fox-admin/racket-stringing', icon: 'form', selected: false, feature: 'stringing' },
        { id: 42, title: 'Lịch sử phiếu', url: '/fox-admin/racket-stringing-list', icon: 'unordered-list', selected: false, feature: 'stringing' },
        { id: 7, title: 'Trang dịch vụ', url: '/fox-admin/services', icon: 'appstore', selected: false, feature: 'svc' },
      ],
    },
    {
      id: 300,
      title: 'Sản phẩm',
      icon: 'shop',
      selected: false,
      children: [
        { id: 32, title: 'Sản phẩm', url: '/fox-admin/settings/product/list', icon: 'shop', selected: false, feature: 'product' },
        { id: 38, title: 'Loại sản phẩm', url: '/fox-admin/settings/product-type', icon: 'appstore', selected: false, feature: 'ptype' },
        { id: 36, title: 'Hãng', url: '/fox-admin/settings/branch', icon: 'apartment', selected: false, feature: 'branch' },
        { id: 33, title: 'Nhà cung cấp', url: '/fox-admin/settings/supplier', icon: 'truck', selected: false, feature: 'supplier' },
        { id: 39, title: 'Sửa giá hàng loạt', url: '/fox-admin/settings/product/bulk-price', icon: 'dollar', selected: false, feature: 'bulk-price' },
      ],
    },
    {
      id: 400,
      title: 'Khách & nhân sự',
      icon: 'team',
      selected: false,
      children: [
        { id: 35, title: 'Khách hàng', url: '/fox-admin/settings/customer/list', icon: 'contacts', selected: false, feature: 'customer' },
        { id: 51, title: 'Lịch làm việc', url: '/fox-admin/work-schedule', icon: 'calendar', selected: false, feature: 'shift' },
        { id: 52, title: 'Chấm công', url: '/fox-admin/attendance', icon: 'clock-circle', selected: false, feature: 'attendance' },
        { id: 53, title: 'Bảng công', url: '/fox-admin/timesheet', icon: 'table', selected: false, feature: 'timesheet' },
        { id: 54, title: 'Ca làm', url: '/fox-admin/work-shift', icon: 'field-time', selected: false, feature: 'timesheet' },
        // Mục "Nhân viên" (collection `employee`) đã gỡ ngày 2026-09-30: nhân
        // viên nay chính là TÀI KHOẢN, quản lý ở Hệ thống → Tài khoản. Route
        // /fox-admin/settings/employee vẫn còn để Admin tra dữ liệu cũ bằng URL.
      ],
    },
    {
      id: 500,
      title: 'Nội dung web',
      icon: 'layout',
      selected: false,
      children: [
        { id: 111, title: 'Trang chủ (Cover)', url: '/fox-admin/home-config', icon: 'layout', selected: false, feature: 'home-cfg' },
        { id: 112, title: 'Giới thiệu', url: '/fox-admin/about-config', icon: 'info-circle', selected: false, feature: 'about-cfg' },
        { id: 113, title: 'Tin tức', url: '/fox-admin/news', icon: 'read', selected: false, feature: 'news' },
        { id: 115, title: 'Flash Sale', url: '/fox-admin/flash-sale', icon: 'thunderbolt', selected: false, feature: 'flash' },
        { id: 114, title: 'Liên hệ', url: '/fox-admin/contact-config', icon: 'phone', selected: false, feature: 'contact-cfg' },
      ],
    },
    {
      id: 600,
      title: 'Đua vịt',
      icon: 'trophy',
      selected: false,
      children: [
        { id: 12, title: 'Lượt đua', url: '/fox-admin/duck-race', icon: 'trophy', selected: false, feature: 'duck-race' },
        { id: 13, title: 'Kho quà', url: '/fox-admin/duck-race/gifts', icon: 'gift', selected: false, feature: 'duck-race' },
      ],
    },
    {
      id: 700,
      title: 'Hệ thống',
      icon: 'setting',
      selected: false,
      children: [
        { id: 31, title: 'Tài khoản', url: '/fox-admin/settings/user', icon: 'user', selected: false, feature: 'user' },
        { id: 37, title: 'Vị trí & phân quyền', url: '/fox-admin/settings/position', icon: 'safety-certificate', selected: false, feature: 'position' },
      ],
    },
  ];

  menuSelected: any = {};
  /** Nhóm đang mở trên thanh ngang. */
  activeGroup: any = null;
  /**
   * Các tác vụ của nhóm đang mở, tính sẵn để đổ ra hàng tab.
   * Không dùng getter trả mảng mới: *ngFor sẽ thấy mảng khác nhau mỗi vòng
   * change detection và làm treo trang.
   */
  subTabs: any[] = [];

  isMobileView = window.innerWidth <= 768;
  drawerVisible = false;

  @HostListener('window:resize')
  onResize() {
    this.isMobileView = window.innerWidth <= 768;
  }

  constructor(
    private approvalService: ApprovalService,
    private router: Router,
    private auth: AngularFireAuth,
    private permission: PermissionService
  ) {
    this.auth.authState.subscribe(async (authUser) => {
      if (!authUser) {
        this.router.navigate(['/fox-admin/login']);
      }
    });
  }

  ngOnInit(): void {
    this.menus = this.getMenuByRole();
    // Vào lại bằng F5 / tab mới: nạp lại ma trận quyền từ Firestore rồi dựng
    // menu lần nữa, để Admin vừa đổi quyền là thấy ngay ở lần tải kế tiếp.
    this.permission.refresh().subscribe(() => {
      this.menus = this.getMenuByRole();
      this.syncFromUrl();
    });
    this.syncFromUrl();
    // Địa chỉ đổi bằng cách nào cũng phải tô sáng đúng nhóm & tác vụ: bấm menu,
    // bấm link trong trang, bấm Back, hay gõ thẳng địa chỉ.
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => this.syncFromUrl());
  }

  // ===== Điều hướng =====

  /** Bấm tên nhóm: mở hàng tab của nhóm và vào thẳng tác vụ đầu tiên. */
  selectGroup(group: any): void {
    this.activeGroup = group;
    this.subTabs = group?.children || [];
    const first = group?.children?.length ? group.children[0] : group;
    if (first?.url) this.goItem(first);
  }

  goItem(item: any): void {
    this.menuSelected = item;
    this.approvalService.updateShowIcon(false);
    this.approvalService.updateMenu(item);
    localStorage.removeItem('parentRouting');
    this.router.navigate([item.url]);
  }

  /** Tìm nhóm & tác vụ khớp địa chỉ hiện tại. Khớp dài nhất thắng. */
  private syncFromUrl(): void {
    const url = this.router.url.split('?')[0].split('#')[0];
    let bestGroup: any = null;
    let bestItem: any = null;
    let bestLen = -1;

    for (const group of this.menus) {
      const items = group.children?.length ? group.children : [group];
      for (const item of items) {
        if (!item.url) continue;
        // Dashboard là '/fox-admin' nên phải khớp tuyệt đối, không thì nó nuốt
        // hết mọi màn con.
        const hit =
          item.url === '/fox-admin'
            ? url === '/fox-admin' || url === '/fox-admin/'
            : url === item.url || url.startsWith(item.url + '/');
        if (hit && item.url.length > bestLen) {
          bestLen = item.url.length;
          bestGroup = group;
          bestItem = item;
        }
      }
    }

    if (!bestGroup) return; // màn lạ: giữ nguyên nhóm đang mở
    this.activeGroup = bestGroup;
    this.subTabs = bestGroup.children || [];
    this.menuSelected = bestItem;
    this.approvalService.updateMenu(bestItem);
    this.approvalService.updateShowIcon(false);
  }

  // ===== Điện thoại =====

  isMobile(): boolean {
    return this.isMobileView;
  }

  openDrawer() {
    this.drawerVisible = true;
  }

  closeDrawer() {
    this.drawerVisible = false;
  }

  navigateMobile(item: any) {
    this.closeDrawer();
    this.goItem(item);
  }

  // ===== Lọc menu theo quyền =====

  getMenuByRole() {
    return this.getData(this.menus)
      .map((item: any) =>
        item.children ? { ...item, children: this.getData(item.children) } : { ...item }
      )
      // Nhóm không còn tác vụ nào thì bỏ luôn khỏi thanh nhóm.
      .filter((item: any) => !item.children || item.children.length > 0);
  }

  getData(datas: any) {
    // Mục không khai báo feature (các nhóm) luôn giữ lại — nhóm rỗng đã bị lọc
    // ở bước sau. Mục có feature thì hỏi đúng ma trận quyền của vị trí.
    return datas.filter((m: any) => !m.feature || canViewFeature(m.feature));
  }
}
